import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(Draggable);

// -------------- Testimonials --------------

const heroCarousel = document.querySelector(".hero-carousel");
const animationDuration = 0.6;

if (heroCarousel) {
  const carouselDots = heroCarousel.querySelectorAll(".nav-dot");
  const imageSlides = heroCarousel.querySelectorAll(".image-slide");
  const contentSlides = heroCarousel.querySelectorAll(".content-slide");
  const heroImagesWrapper = heroCarousel.querySelector(".hero-image-slides");
  const heroSpacer = document.querySelector(".hero-spacer");
  let proxy = document.createElement("div");
  let activeSlideIndex = 0;
  let mm = gsap.matchMedia(),
    breakPoint = 992;

  mm.add(
    {
      isDesktop: `(min-width: ${breakPoint}px)`,
      isMobile: `(max-width: ${breakPoint - 1}px)`,
    },
    (context) => {
      let { isDesktop, isMobile } = context.conditions;

      gsap.set(".content-slide", {
        autoAlpha: 0,
        y: isDesktop ? 40 : 0,
      });
    }
  );

  // Swipe Control
  const goToPrevSlide = () => {
    activeSlideIndex =
      (activeSlideIndex - 1 + imageSlides.length) % imageSlides.length;
    transitionSlide(activeSlideIndex);
  };

  const goToNextSlide = () => {
    activeSlideIndex = (activeSlideIndex + 1) % imageSlides.length;
    transitionSlide(activeSlideIndex);
  };

  const initSwiping = () => {
    Draggable.create(proxy, {
      trigger: heroImagesWrapper,
      type: "x",
      minimumMovement: 10,
      dragClickables: true,
      onDragStart: function () {
        this.getDirection() === "left" ? goToNextSlide() : goToPrevSlide();
      },
    });
  };

  const initReveal = () => {
    let nextImageSlide = document.querySelector(".image-slide.active");
    let nextContentSlide = document.querySelector(".content-slide.active");
    revealNextImageSlide(nextImageSlide);
    if (nextContentSlide) revealNextContentSlide(nextContentSlide);
  };

  const revealNextImageSlide = (nextSlide) => {
    gsap.to(nextSlide, {
      duration: animationDuration,
      autoAlpha: 1,
    });
  };

  const revealNextContentSlide = (nextSlide) => {
    gsap.to(nextSlide, {
      duration: animationDuration,
      autoAlpha: 1,
      y: 0,
    });
  };

  const adjustHeight = (el, dur) => {
    if (el) {
      let padding = 48;
      let buttonOffset = 24;
      let offset = 80;
      let newHeight = el.getBoundingClientRect().height;

      mm.add(
        {
          isDesktop: `(min-width: ${breakPoint}px)`,
          isMobile: `(max-width: ${breakPoint - 1}px)`,
        },
        (context) => {
          let { isDesktop, isMobile } = context.conditions;

          gsap.to(heroSpacer, {
            duration: dur,
            height: isDesktop
              ? newHeight - offset - padding + buttonOffset
              : newHeight + buttonOffset,
          });
        }
      );
    } else {
      gsap.to(heroSpacer, {
        duration: dur,
        height: 0,
      });
    }
  };

  const setActiveClasses = (index) => {
    // Move Active Class
    imageSlides.forEach((img, i) => {
      img.classList.remove("active");
      carouselDots[i].classList.remove("active");
      if (contentSlides[i]) contentSlides[i].classList.remove("active");
      if (i === index) {
        img.classList.add("active");
        carouselDots[i].classList.add("active");
        if (contentSlides[i]) contentSlides[i].classList.add("active");
      }
    });
  };

  // Function to show the current slide
  const transitionSlide = (index) => {
    let currentActiveImageSlide = document.querySelector(".image-slide.active");
    let currentActiveContentSlide = document.querySelector(
      ".content-slide.active"
    );

    setActiveClasses(index); // Update Slide Index
    adjustHeight(contentSlides[index], animationDuration); // Adjust Height

    // Begin animating slides
    // Hide Image Slide
    gsap.to(currentActiveImageSlide, {
      duration: animationDuration,
      autoAlpha: 0,
    });

    // Hide Content Slide
    if (currentActiveContentSlide) {
      mm.add(
        {
          isDesktop: `(min-width: ${breakPoint}px)`,
          isMobile: `(max-width: ${breakPoint - 1}px)`,
        },
        (context) => {
          let { isDesktop, isMobile } = context.conditions;

          gsap.to(currentActiveContentSlide, {
            duration: animationDuration,
            autoAlpha: 0,
            y: isDesktop ? 40 : 0,
          });
        }
      );
    }

    initReveal();
  };

  Array.from(carouselDots).forEach((dot, index) => {
    dot.onclick = (e) => {
      e.preventDefault();
      activeSlideIndex = index % carouselDots.length;
      transitionSlide(activeSlideIndex);
    };
  });

  // Show the first slide
  console.info("heroCarousel", {
    heroCarousel,
    carouselDots,
    imageSlides,
    contentSlides,
    heroImagesWrapper,
    heroSpacer,
    proxy,
    activeSlideIndex,
    mm,
    breakPoint,
  });

  setActiveClasses(activeSlideIndex);

  initReveal();

  setInterval(() => {
    activeSlideIndex =
      activeSlideIndex >= carouselDots.length - 1 ? 0 : activeSlideIndex + 1;

    console.info("nextSlideIndex", { activeSlideIndex });

    //revealNextImageSlide(imageSlides[nextSlideIndex]);
    //transitionSlide(imageSlides[nextSlideIndex]);

    if (contentSlides[activeSlideIndex]) {
      transitionSlide(activeSlideIndex);
      adjustHeight(contentSlides[activeSlideIndex], 0);
    }
  }, 8000);

  initSwiping(); // Initialise swiping
}
